// Splide is fetched only on pages with a slider, so it stays out of the main bundle.
const loadSplide = () => Promise.all([
    import('@splidejs/splide'),
    import('@splidejs/splide-extension-auto-scroll'),
]);

export default (params) => ({
    slider: null,
    progressBar: null,
    sliderIsInitialized: false,
    init() {
        this.initSlider()
    },
    async initSlider() {
        if (this.$el.classList.contains("splide")) {
            const [{ Splide }, { AutoScroll }] = await loadSplide();
            this.slider = new Splide(this.$el, {
                ...params,
            })

            this.progressBar = this.$el.querySelector( '.custom-slider-progress-bar' );

            if (this.slider){
                if (this.progressBar){
                    this.slider.on('mounted move', () => this.calculateProgressBarWidth())

                    window.addEventListener("resize", ()=>{
                        if (window.innerWidth <= 990){
                            this.slider.on('mounted move', () => this.calculateProgressBarWidth())
                        }
                    })
                }

                this.slider.on('ready', ()=> {
                    this.sliderIsInitialized = true
                })
            }

            this.slider.mount({AutoScroll});
        }
    },
    calculateProgressBarWidth(){
        const end = this.slider.Components.Controller.getEnd() + 1;
        const rate = Math.min((this.slider.index + 1) / end, 1);

        if (this.progressBar){
            this.progressBar.style.width = String(100 * rate) + '%';
        }
    }
})
